import Swal from 'sweetalert2';

const REVEAL_NAV_DELAY_MS = 3200;
const DEMO_SUBSCRIBE_SWAL_Z_INDEX = 9999;

function showDemoSubscribePopup() {
  Swal.fire({
    icon: 'info',
    text: 'Subscribe to a plan to play more.',
    confirmButtonText: 'OK',
    allowOutsideClick: false,
    allowEscapeKey: false,
    customClass: {
      container: 'demo-subscribe-swal-container',
    },
    didOpen: () => {
      const container = Swal.getContainer();
      if (container) {
        container.style.zIndex = String(DEMO_SUBSCRIBE_SWAL_Z_INDEX);
      }
    },
  }).then(() => {
    window.location.href = (process.env.REACT_APP_BASE_URL || '') + '/plans';
  });
}

export function isDemoSubscribeRedirectUser(user) {
  if (!user || typeof user !== 'object') return false;
  const role = String(user.role ?? '').trim().toUpperCase();
  if (role !== 'DEMOBYPASS') return false;
  const sid = String(user.sessionId ?? '').toLowerCase();
  const oid = String(user.organizationId ?? '').toLowerCase();
  return sid.includes('demo') && oid.includes('demo');
}

export function isUserDemoBypass(user) {
  return isDemoSubscribeRedirectUser(user);
}

export function demoSubscribePopupAndRedirect() {
  window.setTimeout(() => {
    showDemoSubscribePopup();
  }, 400);
}
